/**
 * Gets value of a LocalStorage Item. Returns true if key has never been set.
 * @param key
 * @returns {boolean|boolean|*} true if the key has never been set. False if there is an error with local storage.
 */
export function getValue(key) {
    try {
        return !global.localStorage || global.localStorage.getItem(key);
    } catch (error) {
        console.warn("error while reading localStorage", error);
        return false;
    }
}

export function setValue(key, value) {
    try {
        if (global.localStorage) {
            global.localStorage.setItem(key, value);
        }
    } catch (error) {
        console.warn("error while writing to localStorage", error);
    }
}

const exported = { getValue, setValue };

export default exported;
